import moment from 'moment';

export class DefaultMissionTimeCalculator{
    calculate = (): { startTime: string, durationMinutes: number} => {

        // startTime is next 5-minute boundary that is > 4 mins ahead of now
        // examples:
        // at 3:10:59 return 3:15
        // at 3:11:00 return 3:20
        const nowPlusBuffer = moment().add(4, 'minutes').startOf('minute');
        const boundaryOffset = 5 - (nowPlusBuffer.minute() % 5);
        const startTime = nowPlusBuffer.add(boundaryOffset, 'minutes').toISOString();

        return {
            startTime,
            durationMinutes: 60
        };
    };
}
